import { ComponentProps, FC } from "react";

import { VnButton } from "@/components/VnButton/VnButton";
import { VnLink } from "@/components/VnLink";
import { VnText } from "@/components/VnText/VnText";
import {
  SUPPORT_PHONE_NUMBER,
  SUPPORT_PHONE_NUMBER_URL,
} from "@/domain/constants";
import { cn } from "@/utils/tailwind";

type SupportCallButtonPropsType = Omit<
  ComponentProps<typeof VnButton>,
  "children" | "IconComponent" | "iconPosition" | "i18nKey" | "onPress"
>;

export const SupportCallButton: FC<SupportCallButtonPropsType> = ({
  className,
  textClassName,
}) => (
  <VnLink
    href={SUPPORT_PHONE_NUMBER_URL}
    className={cn("items-center justify-center", className)}>
    <VnText
      variant="mdMedium"
      className={cn("text-foreground", textClassName)}
      i18nKey="native:support.callUsAt"
      i18nOptions={{ phoneNumber: SUPPORT_PHONE_NUMBER }}
    />
  </VnLink>
);
